<section>
  <div class="title--container">
    <span class="subtitle2">Flask {{ flaskLabel() }}</span>
    <app-svg-template
      [iconName]="flaskIcon()"
      [title]="flaskIcon()"
      height="30"
      width="30"
      customViewBox="0 0 30 30"
    ></app-svg-template>
  </div>
  @if (data(); as d) {
    @switch (d.kind) {
      @case ("od") {
        @if (d.offset !== null) {
          <div class="row">
            <span class="body1 title">Offset (p0):</span>
            <span class="body1 data">{{ d.offset }}</span>
          </div>
        }
        @if (d.factor !== null) {
          <div class="row">
            <span class="body1 title">Factor (p1):</span>
            <span class="body1 data">{{ d.factor }}</span>
          </div>
        }
        @if (d.power !== null) {
          <div class="row">
            <span class="body1 title">Power (p2):</span>
            <span class="body1 data">{{ d.power }}</span>
          </div>
        }
        @if (d.rSquared !== null) {
          <div class="row">
            <span class="body1 title">R<sup>2</sup>:</span>
            <span class="body1 data">{{ d.rSquared }}</span>
          </div>
        }
        @if (d.temperature !== null) {
          <div class="row">
            <span class="body1 title">Temperature:</span>
            <span class="body1 data">{{ d.temperature }}</span>
          </div>
        }
      }
      @case ("oxygen") {
        @if (d.dphi !== null) {
          <div class="row">
            <span class="body1 title">dPhi:</span>
            <span class="body1 data">{{ d.dphi }}</span>
          </div>
        }
        @if (d.temperature !== null) {
          <div class="row">
            <span class="body1 title">Temperature:</span>
            <span class="body1 data">{{ d.temperature }}</span>
          </div>
        }
        @if (d.pressure !== null) {
          <div class="row">
            <span class="body1 title">Pressure:</span>
            <span class="body1 data">{{ d.pressure }}</span>
          </div>
        }
        @if (d.hasError !== null) {
          <div class="row">
            <span class="body1 title">Has Error:</span>
            <span class="body1 data">{{ d.hasError ? "Yes" : "No" }}</span>
          </div>
        }
      }
      @case ("ph") {
        @if (d.slope !== null) {
          <div class="row">
            <span class="body1 title">Slope:</span>
            <span class="body1 data">{{ d.slope }}</span>
          </div>
        }
        @if (d.mVOffset !== null) {
          <div class="row">
            <span class="body1 title">Offset [mV]:</span>
            <span class="body1 data">{{ d.mVOffset }}</span>
          </div>
        }
        @if (d.phCalFactor !== null) {
          <div class="row">
            <span class="body1 title">Calibration Factor:</span>
            <span class="body1 data">{{ d.phCalFactor }}</span>
          </div>
        }
        @if (d.phCalOffset !== null) {
          <div class="row">
            <span class="body1 title">Calibration Offset:</span>
            <span class="body1 data">{{ d.phCalOffset }}</span>
          </div>
        }
        @if (d.rSquared !== null) {
          <div class="row">
            <span class="body1 title">R<sup>2</sup>:</span>
            <span class="body1 data">{{ d.rSquared }}</span>
          </div>
        }
      }
      @case ("sparging") {
        @if (d.slope !== null) {
          <div class="row">
            <span class="body1 title">Slope:</span>
            <span class="body1 data">{{ d.slope }}</span>
          </div>
        }
        @if (d.intercept !== null) {
          <div class="row">
            <span class="body1 title">Intercept:</span>
            <span class="body1 data">{{ d.intercept }}</span>
          </div>
        }
        @if (d.rSquared !== null) {
          <div class="row">
            <span class="body1 title">R<sup>2</sup>:</span>
            <span class="body1 data">{{ d.rSquared }}</span>
          </div>
        }
      }
    }
  }
</section>
